import { base_url } from "../Api/ApiConst";

export const getImageUrl = (url: string | undefined | null): string => {
  if (!url) return "";
  
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  
  const cleanBaseUrl = base_url.endsWith("/") ? base_url.slice(0, -1) : base_url;
  const cleanUrl = url.startsWith("/") ? url : `/${url}`;
  
  return `${cleanBaseUrl}${cleanUrl}`;
};
